import { StyledInput } from 'components/shared/Input/styles';
import styled from 'styled-components';
export const StyledEditablePhoneInput = styled.div`
  position: relative;

  display: flex;
  flex-wrap: wrap;

  margin: auto;

  max-width: 43rem;

  @media screen and (min-width: 768px) {
    align-items: end;
    gap: 1rem;

    margin: 0;
  }
  ${StyledInput} {
    border-radius: 6px;

    background-color: ${({ theme }) => (theme.id === 'dark' ? theme.text3 : theme.accent3)};
    &::placeholder {
      color: ${({ theme }) => (theme.id === 'dark' ? theme.bg3 : theme.text4)};
    }
  }

  .phone-input-group {
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: 100%;

    @media screen and (min-width: 768px) {
      flex-grow: 0;
      flex-basis: 32rem;
      max-width: 31rem;
    }
    @media screen and (min-width: 1100px) {
      max-width: 32rem;
    }
  }
  .phone-input-label {
    display: block;

    padding: 0 1rem;

    font-size: 1rem;
    font-weight: 400;
    line-height: 150%;
    color: ${({ theme }) => (theme.id === 'dark' ? theme.text2 : theme.text1)};

    @media screen and (min-width: 768px) {
      margin-bottom: 0.5rem;

      font-size: 1.6rem;
    }
  }
  .phone-input-container {
    position: relative;

    margin-bottom: 0.6rem;

    @media screen and (min-width: 768px) {
      margin-bottom: 0;
    }

    .phone-editable-input {
      color: white;

      &:disabled {
        color: white;
        cursor: pointer;
        &::placeholder {
          color: white;
        }
      }
    }
  }
  .phone-editable-edit-button {
    position: absolute;
    right: 1rem;
    bottom: 50%;
    transform: translateY(50%);

    display: flex;
    align-items: center;

    width: 2.5rem;

    &:hover:not(.editing) {
      color: ${({ theme }) => (theme.id === 'dark' ? theme.button1 : theme.button1)};
    }
    &.editing {
      color: ${({ theme }) => (theme.id === 'dark' ? theme.accent1 : theme.button1)};
    }

    &__icon {
      display: block;
      *[fill] {
        fill: currentColor;
      }
    }
  }

  .phone-editable-qr-button {
    margin-left: auto;
    @media screen and (min-width: 768px) {
      margin-left: 0;
    }
  }
  .phone-input-controls {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
